import React, { useContext, useState, useCallback, memo } from "react";
import { useSelector } from "react-redux";
import { DF_OT0018Context } from "../context";
import BizinBackend from "../../../../helpers/bizin_helper";
import useGetCsrfToken from "../../../../Hooks/useGetCsrfToken";
import useGetHeightPage from "../../../../Hooks/useGetHeightPage";

const PROC_EXCLUIR = "FRONT_Workspace_DF_OT0018_Desativar_Categoria";

const parseProcedureResponse = (res) => {
  const target = res?.response || res;
  const data = target?.data?.data?.[0] || target?.data?.resultset_1?.[0] || target?.resultset_1?.[0] || target?.data || target;

  const hasError =
    !res ||
    res.error ||
    target?.success === false ||
    (target?.statusCode || target?.status || data?.statusCode || 200) >= 400 ||
    data?.Status === "ERROR";

  const message = target?.message?.replace(/^Error:\s*/, "") || data?.Message || data?.message || "";

  return { hasError, message };
};

function GridBody() {
  const { userId, idCategoria, idEmpresaOrigem, idEmpresaDestino, navigate } =
    useContext(DF_OT0018Context);

  const access_token = useSelector((state) => state.login.user?.access_token);
  const csrfToken = useGetCsrfToken();
  useGetHeightPage();

  const [loading, setLoading] = useState(false);
  const [screenMode, setScreenMode] = useState("confirm");
  const [errorMessage, setErrorMessage] = useState("");

  const handleCloseModal = useCallback(
    (reloadParent = false) => {
      if (window.top !== window.self) {
        window.parent.postMessage({ type: "closeModal", isReloadPage: reloadParent }, "*");
      } else if (navigate) {
        navigate(-1);
      } else {
        window.close();
      }
    },
    [navigate]
  );

  const handleConfirmDelete = async () => {
    try {
      setLoading(true);

      const response = await BizinBackend.executeProcedure(
        { 1: userId, 2: idCategoria, 3: idEmpresaOrigem, 4: idEmpresaDestino },
        PROC_EXCLUIR,
        csrfToken,
        access_token
      );

      const { hasError, message } = parseProcedureResponse(response);

      if (hasError) {
        setErrorMessage("Não foi possível desativar a categoria. Tente novamente.");
        setScreenMode("error");
        return;
      }

      setScreenMode("success");
    } catch (error) {
      const { message } = parseProcedureResponse(error);
      setErrorMessage("Ocorreu uma falha na comunicação com o servidor. Tente novamente.");
      setScreenMode("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {screenMode === "confirm" && (
        <div className="text-center">
          <div className="icon-warning mb-4">
            <i className="fas fa-exclamation-triangle"></i>
          </div>

          <h5 className="modal-title-custom mb-3">Deseja desativar esta categoria?</h5>

          <p className="modal-description mb-4">
            Ao clicar em "Confirmar", a categoria selecionada será <br /> desativada.
          </p>

          <div className="d-flex justify-content-center gap-3">
            <button
              type="button"
              className="btn border-0 fw-bold px-4 btn-cancelar-co0005"
              onClick={() => handleCloseModal(false)}
              disabled={loading}
            >
              Cancelar
            </button>

            <button
              type="button"
              className="btn border-0 fw-bold px-4 btn-confirmar-co0005"
              onClick={handleConfirmDelete}
              disabled={loading}
            >
              {loading ? "Processando..." : "Confirmar"}
            </button>
          </div>
        </div>
      )}

      {screenMode === "success" && (
        <div className="text-center">
          <div className="icon-success mb-4">
            <i className="fas fa-check"></i>
          </div>

          <h5 className="modal-title-custom mb-3">Sucesso!</h5>
          <p className="modal-subtext mb-4">Categoria desativada com sucesso.</p>

          <button
            type="button"
            className="btn border-0 fw-bold px-4 btn-confirmar-co0005"
            onClick={() => handleCloseModal(true)}
          >
            Ok!
          </button>
        </div>
      )}

      {screenMode === "error" && (
        <div className="text-center">
          <div className="icon-error mb-4">
            <i className="fas fa-times"></i>
          </div>

          <h5 className="modal-title-custom mb-3">Erro ao desativar categoria</h5>
          <p className="modal-description mb-4">{errorMessage}</p>

          <div className="d-flex justify-content-center gap-2">
            <button
              type="button"
              className="btn border-0 fw-bold px-4 btn-cancelar-co0005"
              onClick={() => handleCloseModal(false)}
            >
              Fechar
            </button>

            <button
              type="button"
              className="btn border-0 fw-bold px-4 btn-confirmar-co0005"
              onClick={() => setScreenMode("confirm")}
            >
              Tentar Novamente
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default memo(GridBody);